import { Gig } from "../gig";
import { Project } from "../project";
import Season_Entity from "./season";
export default class Season extends Season_Entity {
  static fromList(seasonsJSON: unknown): Array<Season> {
    const seasons: Season[] = [];
    if (seasonsJSON)
      Array.isArray(seasonsJSON) &&
        seasonsJSON.forEach((seasonJSON) => {
          seasons.push(new Season(seasonJSON));
        });
    return seasons;
  }

  toJson(): string {
    return JSON.stringify(this);
  }

  inject({ projects, gigs }: { projects: Project[]; gigs: Gig[] }) {
    const _projects =
      projects?.filter((g) => g.seasonID == this.sourceRecordID) ?? [];

    this.projects = [];
    _projects.forEach((p) => {
      let _p = p;
      if (gigs != null) {
        _p = p.inject({ gigs: gigs });
      }
      this.projects.push(_p);
    });

    return this;
  }

  dateDescription(): string {
    const from = this.from();
    const to = this.to();

    const fromFormat = from != null ? from.format("M/D/yyy") : "";
    const toFormat = to != null ? to.format("M/D/yyy") : "";

    if (fromFormat == toFormat) return fromFormat;

    if (from != null && to != null) {
      return `From ${fromFormat} to ${toFormat}`;
    }

    return "Unknown dates";
  }

  projectCount() {
    return this.projects?.length ?? 0;
  }

  completedProjectCount() {
    let completed = 0;

    this.projects?.forEach((g) => {
      if (g.completed()) completed++;
    });
    return completed;
  }

  completion() {
    if (this.projectCount() != 0) {
      return this.completedProjectCount() / this.projectCount();
    }
    return 0;
  }

  from() {
    let min;

    try {
      if (this.projects.length) min = this.projects[0].from();
    } catch (e) {
      console.log(e);
    }

    this.projects?.forEach((g) => {
      if (g.from()?.isBefore(min) ?? false) {
        min = g.from();
      }
    });

    return min;
  }

  to() {
    let max;

    try {
      if (this.projects.length) max = this.projects[0].to();
    } catch (e) {
      console.log(e);
    }

    this.projects?.forEach((g) => {
      if (g.to()?.isAfter(max) ?? false) {
        max = g.to();
      }
    });

    return max;
  }
}
